/* eslint-disable react/prop-types */
// Imports
import React from "react";
import { useQuiz } from "src/contexts/QuizContext.js";

const QuizButtonStart = ({
  action = null,
  value = null,
  label = "Start the quiz",
}) => {
  const { dispatch } = useQuiz();
  return (
    <button
      className="quiz-main__back-button"
      aria-label={label}
      onClick={(e) => {
        e.preventDefault();
        dispatch({
          type: action,
          payload: {
            value,
          },
        });
      }}
    >
      <span>{label}</span>
    </button>
  );
};

export default QuizButtonStart;
